import React, { useEffect, useState } from "react";
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import { Box, Button, Grid, IconButton, InputBase, Paper, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Rating from '@mui/material/Rating';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getServiceById } from "../../actions/userAuth";

export default function FeaturedService() {
  const [service, setService] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getServiceById({ id }, (data) => {
      setService(data.data.data);
    }))
  }, [id]);
  return (
    <>
      <Layout>
        <UserLayout userRole={"candidate"}>
          <Box sx={{ display: 'flex', flexDirection: 'row', mt: 8, borderRadius: '10px' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Service Name</Typography>
            <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
              {/* <TextField
                sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                className='profile-skills-box text2Light'
                variant="outlined"
                size="small"
                placeholder="Search"

                InputProps={{
                  endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                }}
              /> */}
            </Grid>
          </Box>
          <Box >
            <Paper sx={{
              border: '1.28px solid #D2D2D24D', boxShadow: '0px 40.996337890625px 81.99267578125px -15.373626708984375px #3665D014', my: 3
            }}>
              <Box p={3}>
                <Typography sx={{
                  lineHeight: "3rem",
                  textAlign: "left",
                  mt: 2
                }}
                  className="heading2bold">{service?.serviceName}</Typography>
                <Rating name="size-small" defaultValue={4} size="small" />
                <Typography
                  sx={{
                    lineHeight: "2rem",
                    textAlign: "left",
                  }}
                  className="subHeading2Mid">
                  {service?.description}
                </Typography>
                <Typography
                  sx={{
                    lineHeight: "2rem",
                    textAlign: "left",
                    mt: 3
                  }}
                  className="subHeading2Mid">
                  Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa Amet ultricies proin egestas egestas pellentesque adipiscing euismod sit imperdiet.
                </Typography>

                <Box>
                  <Typography sx={{
                    lineHeight: "4rem",
                    textAlign: "left",
                    mt: 1
                  }}
                    className="heading2bold">Service Detail by Coach</Typography>
                  <Typography>
                    {service?.descriptionByCoach}
                  </Typography>
                </Box>

              </Box>
              <Box sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', mb: 5 }}>
                <Typography sx={{
                  py: 2,
                }}
                  className="heading2bold">Price: ₹{service?.earnedPrice}/-</Typography>
                <Button variant="contained" className="text1Mid" sx={{ px: 5, py: 2, bgcolor: '#2544EE', ml: 10 }} endIcon={<KeyboardArrowRightIcon />} onClick={() => navigate(`/candidate/service-details/${service._id}`)}> Buy Now</Button>
              </Box>
            </Paper>
          </Box>
        </UserLayout>
      </Layout>
    </>
  )
}
